import { useAuth } from 'src/components/AuthProvider/AuthProvider';

interface UseBalanceAccountInfoReturn {
  isBalanceAccount: boolean;
  externalBalanceBuyerId: string | null;
  balanceOnboardingId: string | null;
  corpId: string | null;
}

export const useBalanceAccountInfo = (): UseBalanceAccountInfoReturn => {
  const { corpData } = useAuth();

  const externalBalanceBuyerId = corpData?.externalId || null;
  const isBalanceAccount = !!externalBalanceBuyerId;
  const balanceOnboardingId = corpData?.balanceOnboardingId || null;
  const corpId = corpData?.id || null;

  return {
    isBalanceAccount,
    externalBalanceBuyerId,
    balanceOnboardingId,
    corpId,
  };
};
